<template>
  <div id="app">
    <header>
      <h1>
        <router-link :to="{ name: 'ListIndex'}">Long Player</router-link>
      </h1>
      <div id="current-user">
        <p v-if="user">
          <router-link :to="{ name: 'UserView', params: {username: user.username}}">
            {{ user.username }}
          </router-link>
          [<a :href="logoutUrl">Logout</a>]
        </p>
        <p v-if="!user">
          <a :href="spotifyLoginUrl">Login</a>
        </p>
        <p v-if="user">
          <router-link :to="{ name: 'ListCreate'}">Create +</router-link>
        </p>
      </div>
    </header>
    <router-view/>
    <player ref="player"></player>
  </div>
</template>

<script>
import UsersService from '@/services/UsersService'
import Player from '@/components/Player'
export default {
  name: 'App',
  components: {
    Player
  },
  data () {
    return {
      spotifyLoginUrl: '',
      user: null
    }
  },
  mounted () {
    this.spotifyLoginUrl = process.env.API_BASE_URL + '/auth/spotify'
    this.logoutUrl = process.env.API_BASE_URL + '/auth/logout'
    this.getCurrentUser()
  },
  methods: {
    playAlbum (album, list) {
      this.$refs.player.playAlbum(album, list)
    },
    getCurrentUser () {
      UsersService.me().then((me) => {
        this.user = me.data
        console.log('got me', this.user)
        this.$refs.player.initPlayer(this.user)
      }).catch((err) => {
        if (err.statusCode === 401) {
          alert('logged out!')
        }
        this.user = null
      })
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  margin-top: 60px;
  max-width: 800px;
  margin: 0 auto 100px auto;
  padding: 0 20px;
}

a, a:link, a:visited, a:active {
  color: #d91e18
}

header {
  display: flex;
  border-bottom: 2px solid #ccc;
  padding-bottom: 10px;
}
#current-user {
  margin-left: auto;
  text-align: right;
}

#search {
  margin: 30px 0;
}

.album {
  border-bottom: 1px solid #ccc;
  margin-top: 10px;
  padding: 10px 0;
  display: flex;
}

.list ul.albums {
  margin: 0;
  padding: 0;
  overflow-x: scroll;
  white-space: nowrap;
}

p.credit {
  margin-top: 0px;
  font-size: smaller;
}

.list ul.albums li {
  display: inline-block;
  list-style: none;
  margin: 0 10px 10px 0;
}

.list ul.albums li h3 {
  margin-bottom: 5px;
}

#search .album .button,
.album .player {
  margin-left: auto;
}

button, .button {
  display: inline-block;
  background: #d91e18;
  color: white !important;
  padding: 8px 12px;
  font-weight: 300 !important;
  text-transform: uppercase;
  border-radius: 20px;
  margin-left: 5px;
  cursor: pointer;
}

.album button {
}

.album .artist {
  font-weight: normal;
  display: block;
}

.album .title {
  font-weight: bold;
}

.album h2 {
  margin-block-start: 0;
}
.placeholder {
  width: 100px;
  height: 100px;
  background: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/App.vue